import { legacyPlugins } from "/app/node_modules/.pnpm/@unhead+vue@3.4.3_@oxc-project+types@0.152.0_esbuild@0.28.2_lightningcss@1.33.0_oxc-par_7036e0426db38536e1fdc417f634d16c/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}